module.exports = __webpack_public_path__ + "static/media/Buddy_client_page_(optimized)3.2b1d0f47.png";